import xhr from './xhr';

const GeoDataApiUtils = {
  getGeoData() {
    // temporary use geojs.io
    // alternative: https://ipstack.com
    let url = 'https://get.geojs.io/v1/ip/geo.json';
    return xhr(url, {
      method: 'get',
      headers: {
        Accept: 'application/json',
      },
    });
  },
};

export default GeoDataApiUtils;
